import {
  Navbar,
  Footer,
  MainHeading,
  HoverButton,
  Animatespin,
} from "../../components";
import GEMAuditionStatusData from "../../js/gemAuditionStatusData";
import AppStoreIcon from "../../assets/image/App_Store_2x.png";
import GooglePlayIcon from "../../assets/image/Google_Play_2x.png";
import Functions from "./index.function";
import { RxPadding } from "react-icons/rx";

const STATUS_LABELS = {
  pending: "Pending Review",
  under_review: "Under Review",
  approved: "Approved",
  accepted: "Approved",
  rejected: "Rejected",
};

const STATUS_COLORS = {
  pending: "text-goldMetallic",
  under_review: "text-goldMetallic",
  approved: "text-[#1DCCA8]",
  accepted: "text-[#1DCCA8]",
  rejected: "text-orangeCrayola",
};

const GEMAuditionStatus = () => {
  const {
    navigate,
    isLoggedIn,
    isLoadingAuditionStatus,
    auditionStatusValue,
    isRejected,
    rejectionReason,
    register,
    handleSubmit,
    errors,
    onSubmit,
    loadingToapi,
    video,
    proofOfPayment,
    videoPreview,
    proofOfPaymentPreview,
  } = Functions();

  if (isLoggedIn && isLoadingAuditionStatus) {
    return (
      <div className="bg-primary">
        <Navbar />
        <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-10">
          <Animatespin />
        </div>
        <Footer />
      </div>
    );
  }

  const statusLabel = STATUS_LABELS[auditionStatusValue] || "Submitted";
  const statusColor = STATUS_COLORS[auditionStatusValue] || "text-secondary";

  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Registration Received!"}
          dis={" Thank You for Applying to the Acting Auditions"}
          layout={"h-18 sm:h-20 lg:h-36"}
          disStyle={{ fontSize: 35,  marginTop: 25, }}
        />
        <MainHeading
          title={""}
          dis={"Your audition registration has been successfully received and is now under review by our team. Please keep your registered email address accessible and make sure you complete the next important step below."}
          layout={"h-18 sm:h-20 lg:h-36"}
          disStyle={{ fontSize: 25,  marginTop: 0, paddingLeft: 100, paddingRight: 100, lineHeight: '2.5rem'  }}
        />
        <div className="max-w-5xl m-auto xs:pt-3 sm:pt-4 lg:py-5">
          {/* Next step: download the GEM App */}
          <div className="flex flex-col items-center xs:mt-3 sm:mt-3 lg:mt-6">
            <h4 className="font-unboundedBold text-goldMetallic text-center xs:text-lg sm:text-xl lg:text-2xl">
              {GEMAuditionStatusData?.appStep?.title}
            </h4>
            <p className="text-secondary font-onestRegular text-center xs:text-sm sm:text-base lg:text-lg pt-2">
              {GEMAuditionStatusData?.appStep?.subtitle}
            </p>
            <div className="flex items-center gap-7 xs:mt-4 sm:mt-4 lg:mt-6">
              <a
                href="https://apps.apple.com/us/app/gem-global/id6755765029"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all duration-300 transform hover:scale-105 shadow"
              >
                <img
                  src={AppStoreIcon}
                  alt="Download on App Store"
                  className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.geminc.gem"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all duration-300 transform hover:scale-105 shadow"
              >
                <img
                  src={GooglePlayIcon}
                  alt="Get it on Google Play"
                  className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
                />
              </a>
            </div>
            <p className="text-secondary font-onestRegular text-center xs:text-sm sm:text-base lg:text-lg pt-5 max-w-3xl">
              {GEMAuditionStatusData?.appStep?.loginInstruction}
            </p>
          </div>

          {/* App updates */}
          <div className="xs:pt-6 sm:pt-8 lg:pt-10">
            <h4 className="text-goldMetallic font-unboundedBold lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-2">
              {GEMAuditionStatusData?.appUpdates?.title}
            </h4>
            <ul className="list-disc xs:pl-5 sm:pl-6 space-y-2">
              {GEMAuditionStatusData?.appUpdates?.points?.map((point, index) => (
                <li
                  key={index}
                  className="text-secondary lg:text-lg leading-5 lg:leading-tight"
                  style={{ fontSize: 25 }}
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>

          {/* Important note */}
          <div className="xs:pt-6 sm:pt-8 lg:pt-10 bg-[#171717] rounded-3xl xs:p-5 sm:p-6 lg:p-8">
            <p className="text-goldMetallic font-unboundedBold xs:text-sm sm:text-base lg:text-lg uppercase pb-2">
              Important
            </p>
            <p className="text-secondary font-onestRegular xs:text-sm sm:text-base lg:text-lg">
              {GEMAuditionStatusData?.importantNote}
            </p>
          </div>

          {/* Already have the app */}
          <div className="xs:pt-6 sm:pt-8 lg:pt-10">
            <h4 className="text-goldMetallic font-unboundedBold lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-2">
              {GEMAuditionStatusData?.alreadyHaveApp?.title}
            </h4>
            <p className="text-secondary lg:text-lg leading-5 lg:leading-tight" style={{ fontSize: 25 }}>
              {GEMAuditionStatusData?.alreadyHaveApp?.description}
            </p>
          </div>
          {/* Part 1: current audition status */}
          {/* <div className="bg-[#171717] rounded-3xl xs:p-5 sm:p-6 lg:p-8" >
            {!isLoggedIn ? (
              <>
                <p className="text-secondary font-onestRegular text-center xs:text-sm sm:text-base lg:text-lg">
                  Please log in to check your status
                </p>
                <div className="flex justify-center items-center pt-5">
                  <HoverButton
                    onClick={() => navigate("/login")}
                    extraClasses={
                      "group xs:w-48 xs:h-10 sm:w-52 sm:h-12 lg:w-56 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform cursor-pointer hover:scale-105 hover:shadow-md"
                    }
                    BtnTitle={"Log In"}
                    BtnTitleClasses={
                      "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                    }
                  />
                </div>
              </>
            ) : (
              <>
                <p className="text-secondary font-onestRegular xs:text-sm sm:text-base lg:text-lg">
                  Your audition status
                </p>
                <h2
                  className={`font-unboundedBold uppercase xs:text-lg sm:text-xl lg:text-2xl pt-1 ${statusColor}`}
                >
                  {statusLabel}
                </h2>
              </>
            )}

            {isLoggedIn && isRejected && (
              <div className="xs:pt-4 sm:pt-5 lg:pt-6">
                {rejectionReason && (
                  <div className="xs:pb-4 sm:pb-5 lg:pb-6">
                    <p className="text-[#808080] font-onestSemiBold xs:text-sm sm:text-base">
                      Reason for rejection
                    </p>
                    <p className="text-orangeCrayola font-onestRegular xs:text-sm sm:text-base pt-1">
                      {rejectionReason}
                    </p>
                  </div>
                )}

                <p className="text-secondary font-onestRegular xs:text-sm sm:text-base pb-4">
                  You can resubmit your proof of payment and audition video
                  below for another review.
                </p>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  noValidate
                  className="flex flex-col"
                >
                  <div className="w-full">
                    <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary">
                      Proof of Payment <span className="text-errorRed">*</span>
                    </p>
                    <label
                      htmlFor="resubmit_proof_of_payment"
                      className="flex justify-center items-center xs:px-6 sm:px-6 lg:px-8 bg-[#212121] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-3xl cursor-pointer text-[#808080] border-dashed border-2 border-transparent hover:border-goldMetallic transition duration-300"
                    >
                      {proofOfPayment?.[0]?.name ||
                        "Click to upload image (proof of payment)"}
                    </label>
                    <input
                      id="resubmit_proof_of_payment"
                      type="file"
                      accept="image/*"
                      className="hidden"
                      {...register("proof_of_payment", {
                        validate: (value) =>
                          (value && value.length > 0) ||
                          "Proof of payment is required",
                      })}
                    />
                    {errors.proof_of_payment && (
                      <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                        {errors.proof_of_payment.message}
                      </span>
                    )}
                    {proofOfPaymentPreview && (
                      <div className="mt-3">
                        <img
                          src={proofOfPaymentPreview}
                          alt="Proof of payment preview"
                          className="max-h-56 w-auto rounded-2xl border border-[#212121] object-contain"
                        />
                      </div>
                    )}
                  </div>

                  <div className="w-full mt-[18px]">
                    <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary">
                      Audition Video <span className="text-errorRed">*</span>
                    </p>
                    <label
                      htmlFor="resubmit_video"
                      className="flex justify-center items-center xs:px-6 sm:px-6 lg:px-8 bg-[#212121] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-3xl cursor-pointer text-[#808080] border-dashed border-2 border-transparent hover:border-goldMetallic transition duration-300"
                    >
                      {video?.[0]?.name || "Click to upload your audition video"}
                    </label>
                    <input
                      id="resubmit_video"
                      type="file"
                      accept="video/*"
                      className="hidden"
                      {...register("video", {
                        validate: (value) =>
                          (value && value.length > 0) ||
                          "Audition video is required",
                      })}
                    />
                    {errors.video && (
                      <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                        {errors.video.message}
                      </span>
                    )}
                    {videoPreview && (
                      <div className="mt-3">
                        <video
                          src={videoPreview}
                          controls
                          className="max-h-56 w-full rounded-2xl border border-[#212121]"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-center items-center my-8">
                    <HoverButton
                      extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform ${
                        loadingToapi
                          ? ""
                          : "cursor-pointer hover:scale-105 hover:shadow-md"
                      }`}
                      BtnTitle={
                        loadingToapi ? (
                          <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-8 w-8"></div>
                          </div>
                        ) : (
                          "Resubmit"
                        )
                      }
                      disabled={loadingToapi}
                      type={"submit"}
                      BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                        loadingToapi
                          ? ""
                          : "group-hover:scale-110 group-hover:text-primary"
                      }`}
                    />
                  </div>
                </form>
              </div>
            )}
          </div> */}

          {/* Part 2: what happens next */}
          <div className="xs:pt-6 sm:pt-8 lg:pt-10">
            <h4 className="text-goldMetallic font-unboundedBold lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-2">
              {GEMAuditionStatusData?.nextSteps?.title}
            </h4>
            <ul className="list-disc xs:pl-5 sm:pl-6 space-y-2">
              {GEMAuditionStatusData?.nextSteps?.points?.map((point, index) => (
                <li
                  key={index}
                  className=" text-secondary lg:text-lg leading-5 lg:leading-tight"
                  style={{fontSize: 25}}
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GEMAuditionStatus;
